import { applyMiddleware, createStore as originalCreateStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from './reducers';
import memes from '../../memes';
import rootSaga from './sagas';
export const createStore = memes((searchResults) => {
    const saga = createSagaMiddleware();
    const middleware = [saga];
    const baseInitialState = rootReducer(undefined, { type: '@@INIT' });
    const newInitialState = searchResults ? Object.assign(Object.assign({}, baseInitialState), { searchResults }) : baseInitialState;
    if (process.env.NODE_ENV === 'development') {
        middleware.push(require('redux-logger').default);
    }
    const store = originalCreateStore(rootReducer, newInitialState, applyMiddleware(...middleware));
    saga.run(rootSaga);
    return store;
});
